import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { removeToken } from "../../utils/cookies";
import { logout } from "../../redux/slice/userSlice";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";

const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const handleLogout = () => {
    removeToken();
    dispatch(logout());
    navigate("/login");
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="lg:hidden">
        <Navbar
          onMenuClick={toggleSidebar}
          onLogout={handleLogout}
          currentPath={location.pathname}
        />
        <Sidebar
          isOpen={sidebarOpen}
          onClose={() => setSidebarOpen(false)}
          currentPath={location.pathname}
          onLogout={handleLogout}
          isMobile={true}
        />
        <main className="pt-16">{children}</main>
      </div>

      <div className="hidden lg:flex h-screen">
        <Sidebar
          isOpen={true}
          onClose={() => {}}
          currentPath={location.pathname}
          onLogout={handleLogout}
          isMobile={false}
        />
        <div className="flex-1 flex flex-col">
          <Navbar
            onMenuClick={toggleSidebar}
            onLogout={handleLogout}
            currentPath={location.pathname}
            hideLogo={true}
          />
          <main className="flex-1 overflow-auto ">{children}</main>
        </div>
      </div>
    </div>
  );
};

export default Layout;
